module.exports = __webpack_public_path__ + "static/media/savio20.f21ceb02.jpg";